import React from 'react';
import PropTypes from 'prop-types';

import {
  Button,
  ButtonIcon,
  TextIcon
} from '@brandwatch/axiom-components';

import './SlideNavigation.css';

class SlideNavigation extends React.Component {
  constructor(props) {
    super(props);

    this.handleKeyUp = this.handleKeyUp.bind(this);
    this.firstSlide = this.firstSlide.bind(this);
    this.previousSlide = this.previousSlide.bind(this);
    this.nextSlide = this.nextSlide.bind(this);
    this.lastSlide = this.lastSlide.bind(this);
  }

  firstSlide() {
    this.props.firstSlide({slideReferrer: 'button'});
    this.props.track('first slide');
  }

  lastSlide() {
    this.props.lastSlide({slideReferrer: 'button'});
    this.props.track('last slide');
  }

  previousSlide() {
    this.props.previousSlide({slideReferrer: 'button'});
    this.props.track('previous slide');
  }

  nextSlide() {
    this.props.nextSlide({slideReferrer: 'button'});
    this.props.track('next slide');
  }

  componentDidMount() {
    document.addEventListener('keyup', this.handleKeyUp);
  }

  componentWillUnmount() {
    document.removeEventListener('keyup', this.handleKeyUp);
  }

  handleKeyUp(evt) {
    if (evt.key === 'ArrowLeft') {
      evt.shiftKey ? this.firstSlide() : this.previousSlide();
    } else if (evt.key === 'ArrowRight') {
      evt.shiftKey ? this.lastSlide() : this.nextSlide();
    } else if (evt.key === ' ') {
      this.props.togglePauseSlideRotation();
    }
  }

  render() {
    const {slideCount, deckCount, deckIndex, slideIndex, slideName, openFullscreenDialog} = this.props;

    const iconSize = '20px';

    return (
      <div className="SlideNavigation">
        <React.Fragment>
          {(slideCount > 1 || deckCount > 1) && (
            <div className="navigation-end">
              <Button
                disabled={deckCount === 1 ? slideIndex === 0 : deckIndex === 0 && slideIndex === 0}
                onClick={this.firstSlide}
                style="quaternary"
                title="First Slide (Shift + Left Arrow)"
                data-viz-at="button-first"
              >
                <ButtonIcon size={iconSize} name="double-chevron-left" />
              </Button>
              <Button
                size="small"
                shape="circle"
                onClick={this.previousSlide}
                style="quaternary"
                title="Previous Slide (Left Arrow)"
                data-viz-at="button-previous"
              >
                <ButtonIcon size={iconSize} name="chevron-left" />
              </Button>
            </div>
          )}

          <div className="navigation-center" data-viz-at="navigation-center" onClick={() => openFullscreenDialog({type: 'SlidePicker'})}>
            <div className="slide-name" >
              <div className="slide-name-text" data-viz-at="label-slide-name">{slideName}</div>
              <TextIcon inline spaceLeft="x1" name="chevron-up" />
            </div>
            <div className="SlideIndex">{slideIndex + 1}/{slideCount}</div>
          </div>

          {(slideCount > 1 || deckCount > 1) && (
            <div className="navigation-end">
              <Button
                size="small"
                shape="circle"
                onClick={this.nextSlide}
                style="quaternary"
                title="Next Slide (Right Arrow)"
                data-viz-at="button-next"
              >
                <ButtonIcon size={iconSize} name="chevron-right" />
              </Button>
              <Button
                disabled={deckCount === 1 ? slideIndex === slideCount - 1 : deckIndex === deckCount - 1 && slideIndex === slideCount - 1}
                onClick={this.lastSlide}
                style="quaternary"
                title="Last Slide (Shift + Right Arrow)"
                data-viz-at="button-last"
              >
                <ButtonIcon size={iconSize} name="double-chevron-right" />
              </Button>
            </div>
          )}
        </React.Fragment>
      </div>
    );
  }
}

SlideNavigation.propTypes = {
  deckCount: PropTypes.number,
  deckIndex: PropTypes.number,
  firstSlide: PropTypes.func.isRequired,
  lastSlide: PropTypes.func.isRequired,
  nextSlide: PropTypes.func.isRequired,
  previousSlide: PropTypes.func.isRequired,
  slideCount: PropTypes.number.isRequired,
  slideIndex: PropTypes.number.isRequired,
  slideName: PropTypes.string,
  togglePauseSlideRotation: PropTypes.func.isRequired,
  track: PropTypes.func.isRequired,
  openFullscreenDialog: PropTypes.func.isRequired,
};

export default SlideNavigation;
